import { Close } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  TextField,
  Typography,
} from "@mui/material";

import React, { useState } from "react";
import { addInitiateDischargeByVisitIdApi } from "../../../services/consultation.service";
import { toast } from "react-toastify";

const InitialDischargeDetailsModal = ({ open, onClose, id }) => {
  const initialState = {
    dischargeType: "",
    dischargeReason: "",
  };
  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const response = await addInitiateDischargeByVisitIdApi(id, formData);
    if (response?.code === 200 || response?.code === 201) {
      toast.success("Initial Discharge saved successfully");
      setLoading(false);
      setFormData(initialState);
      onClose();
    } else {
      toast.error(response?.message || "Some error occurred!");
      setLoading(false);
    }
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            maxWidth: "unset",
            width: { xs: "95vw", lg: "1100px" },
            bgcolor: "#E5F4FF",
            borderRadius: "20px",
          },
        },
      }}
    >
      <DialogContent>
        {/* dialog title */}
        <Box component={"form"} onSubmit={handleSubmit}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: "20px",
            }}
          >
            <Typography variant="h6" sx={{ color: "#5D6A82" }}>
              Enter Initial Discharge Details
            </Typography>
            <Close
              onClick={onClose}
              sx={{ cursor: "pointer", color: "#5D6A82" }}
            />
          </Box>

          <Grid
            container
            spacing={3}
            sx={{
              mb: "40px",
            }}
          >
            <Grid item xs={12} sm={4}>
              <TextField
                label="Discharge Type"
                name="dischargeType"
                value={formData?.dischargeType || ""}
                onChange={handleChange}
                required
                fullWidth
                sx={{ background: "white" }}
              />
            </Grid>

            <Grid item xs={12} sm={8}>
              <TextField
                label="Discharge Reason"
                name="dischargeReason"
                value={formData?.dischargeReason || ""}
                onChange={handleChange}
                required
                fullWidth
                sx={{ background: "white" }}
              />
            </Grid>
          </Grid>

          {/* submit button */}
          <Box sx={{ my: "20px", textAlign: "center" }}>
            <Button
              variant="contained"
              sx={{ width: "150px", textTransform: "none" }}
              type="submit"
              disabled={loading}
            >
              {loading ? <CircularProgress size={"24px"} /> : "Submit"}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default InitialDischargeDetailsModal;
